import type { BaseKeyFunction } from "../../../lib/types/baseKeyFunction";

export const keyMe: BaseKeyFunction = () => ["me"];
export const keyEmailPreferences: BaseKeyFunction = () => [
  "me",
  "email-preferences",
];

export const keyStreaks = () => ["me", "streaks"];
